import { useEffect, useState } from "react";
import { Eye, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import api from "@/lib/api";

const LABELS = {
  nom: "Nom", entreprise: "Entreprise", poste: "Poste", courriel: "Courriel", telephone: "Téléphone", site_actuel: "Site actuel",
  secteur: "Secteur", taille_equipe: "Taille équipe", clientele: "Clientèle",
  type_projet: "Type de projet", objectifs: "Objectifs", problemes_resoudre: "Problèmes à résoudre",
  fonctionnalites_souhaitees: "Fonctionnalités souhaitées", inspirations: "Inspirations", contenu_disponible: "Contenu disponible",
  public_cible: "Public cible", concurrents: "Concurrents", integrations: "Intégrations",
  multilingue: "Multilingue", seo_requis: "SEO requis", budget: "Budget", delai: "Délai", commentaires: "Commentaires",
};

export default function ProjectBriefsPanel() {
  const [briefs, setBriefs] = useState([]);
  const [view, setView] = useState(null);

  useEffect(() => {
    api.get("/admin/project-briefs").then(({ data }) => setBriefs(data));
  }, []);

  return (
    <div data-testid="briefs-panel">
      <h2 className="font-heading font-bold text-xl text-[#0B1F3A] mb-4">Cahiers des charges reçus</h2>
      <div className="bg-white rounded-xl border border-gray-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[#F5F7FA] text-left">
            <tr>
              <th className="p-3">Date</th><th className="p-3">Entreprise</th><th className="p-3">Contact</th>
              <th className="p-3">Type</th><th className="p-3">Budget</th><th className="p-3">Délai</th><th className="p-3"></th>
            </tr>
          </thead>
          <tbody>
            {briefs.length === 0 && <tr><td colSpan={7} className="p-8 text-center text-[#4B5563]">Aucun cahier des charges pour l'instant.</td></tr>}
            {briefs.map((b) => (
              <tr key={b.id} className="border-t border-gray-100" data-testid={`brief-row-${b.id}`}>
                <td className="p-3 text-[#4B5563]">{new Date(b.created_at).toLocaleDateString("fr-CA")}</td>
                <td className="p-3 font-medium text-[#0B1F3A]">{b.entreprise}</td>
                <td className="p-3 text-[#4B5563]">{b.nom}<br /><span className="text-xs">{b.courriel}</span></td>
                <td className="p-3 text-[#4B5563]">{b.type_projet}</td>
                <td className="p-3 text-[#4B5563]">{b.budget}</td>
                <td className="p-3 text-[#4B5563]">{b.delai}</td>
                <td className="p-3 text-right">
                  <Button size="sm" variant="ghost" onClick={() => setView(b)} data-testid={`brief-view-${b.id}`}><Eye className="h-4 w-4" /></Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog open={!!view} onOpenChange={(v) => !v && setView(null)}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
          {view && (
            <>
              <DialogHeader>
                <DialogTitle className="font-heading">Cahier des charges — {view.entreprise}</DialogTitle>
              </DialogHeader>
              <div className="grid sm:grid-cols-2 gap-x-6 gap-y-3 text-sm pt-3">
                {Object.keys(LABELS).map((k) => (
                  <div key={k}>
                    <div className="text-xs tracking-wider uppercase font-bold text-[#00B8D9] mb-0.5">{LABELS[k]}</div>
                    <div className="text-[#0B1F3A] whitespace-pre-wrap">{view[k] || <span className="text-gray-400">—</span>}</div>
                  </div>
                ))}
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
